import React, { Component } from 'react';
import { Input, Label } from 'components';

import styles from './CodeVerifier.scss';


class CodeVerifier extends Component {
	state = {
		form: this.props.form
	}

  	onPaste = ( e, identifier ) => {

  		if(identifier == 'code_1'){
  			let clipBoardData = e.clipboardData.getData('Text').split('')
			Object.keys(this.state.form).map((input, index) =>

				this.setState(
					prevState => (
						{
				            form: {
				                ...prevState.form,
				                ['code_'+(index+1)]: clipBoardData[index]
				            }
				        }
			        ),
		        	() => this.props.changed(this.state)
				)
		    )
			
  		}


	}

	// Backspace-Funktion
	onKeyUp = (e, target) => {
        if (e.keyCode === 8) {

	        this.setState((prevState, props) => (
			        {
			        	form: {	
				  			...prevState.form, 
				  			[target]: ''
						}
					}
				),
		    	() => this.props.changed(this.state)
		    )
        }

	}

	inputChangedHandler = (event, target) => {
		let value = event.target.value;
/*		let key = event;
		console.log(key);*/
		if(value.length == 1){
	        this.setState((prevState, props) => (
			        {
			        	form: {	
				  			...prevState.form, 
				  			[target]: value
						}
					}
				),
		    	() => this.props.changed(this.state)
		    )
			// Focus next element
			var next = event.srcElement || event.target;
	        while (next = next.nextElementSibling) {
	            if (next == null)
	                break;
	            if (next.tagName.toLowerCase() === "input") {
	                next.focus();
	                break;
	            }
	        }
		}
	}

	render() {

    return (
      <div className={styles.codeVerifier}>
		{Object.keys(this.props.form).map((input, index) =>
			<Input 
				key={index}
				placeholder="0"
				keyupped={(event, target) => {this.onKeyUp(event, target)}}
				identifier={"code_"+(index + 1)}
				type="number"
				value={this.state.form['code_'+(index + 1)]}
				pasted={this.onPaste}
				changed={(event, target) => {this.inputChangedHandler(event, target)}} />
        	
		)}
      </div>
    )
  }
}

export default CodeVerifier



// WEBPACK FOOTER //
// ./src/components/molecules/CodeVerifier/index.js